import "./App.css";
import Game from "./Game";

function App() {
  return (
    <div className="app-container">
      <Game />
    </div>
  );
}

export default App;
